import { Box, Button, Checkbox, Flex, Image, Text, useBreakpointValue } from "@chakra-ui/react"
import { PhoneInput } from "./PhoneInput.component"
import { useEffect, useState } from "react";
import { EmailInput } from "./EmailInput.component";
import { ShowAlert } from "../../../GlobalComponents/ShowAlert/ShowAlert";
import { sendOtp } from "../../Landing/Login/Action/loginAction";
import OtpModal from "../../Landing/Otp/Otp";
import { useNavigate, useParams } from "react-router-dom";
import { findCompanyByName } from "../../Corporate/Actions/findCompanyByName.action";
import { Link as ChakraLink } from '@chakra-ui/react';
import { useSelector } from "react-redux";


interface LoginProps {
    companyName?: string;
}


export const Login = ({ companyName: companyNameProp }: LoginProps) => {
    const { company } = useParams<{ company?: string }>();

    const LogoDirPath = company ? "../Images" : "Images"
    const isCorporate = Boolean(company)
    const isMobile = useBreakpointValue({ base: true, lg: false })

    const [phoneNumber, setPhoneNumber] = useState({
        countryCode: "+91",
        number: "",
    })
    const [email, setEmail] = useState<string>("");
    const [TandCStatus, setTandCStatus] = useState<boolean>(true);
    const [disable, setDisable] = useState(true);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [companyLogoUrl, setCompanyLogoUrl] = useState<string>("");
    const [isSamlAuth, setIsSamlAuth] = useState<boolean>(false);
    const beneficiaryData = useSelector((state: any) => state.beneficiary);
    const navigate = useNavigate();
    const [companyDetails, setCompanyDetails] = useState<any>([])
    const [inputEmailDisable, setEmailDisable] = useState<boolean>(false);
    const [inputPhoneDisable, setPhoneDisable] = useState<boolean>(false);


    useEffect(() => {
        const fetchCompany = async () => {
            try {
                const response = await findCompanyByName(company);
                setCompanyDetails(response?.data[0])
                if (response?.data[0]?.logo) {
                    const logoUrl = response.data[0].logo;

                    if (logoUrl.includes("apis.pococare.com")) {
                        const logoUrlResponse = await fetch(logoUrl);
                        const blob = await logoUrlResponse.blob();
                        const objectUrl = URL.createObjectURL(blob);
                        setCompanyLogoUrl(objectUrl);
                    } else {
                        setCompanyLogoUrl(logoUrl);
                    }
                }
                if (response?.data[0]?.is_Saml_Auth) {
                    setIsSamlAuth(true);
                }

            } catch (err: any) {
                if (err?.response?.data?.statusCode === 404) {
                    navigate("/companyNotFound")

                }
                console.error("Error fetching company:", err);
            }
        };

        if (beneficiaryData.length) {
            return navigate('/dashboard')
        }

        if (company) {
            fetchCompany();
        }
    }, [company, beneficiaryData, navigate]);

    const validateEmail = (email: string): boolean => {
        const emailRegex = /^([a-zA-Z0-9_.+-]+)@([a-zA-Z0-9-]+)(\.[a-zA-Z]{2,5}){1,2}$/;
        return emailRegex.test(email);
    };

    const validatePhoneNumber = (phone: string): boolean => {
        const phoneRegex = /^[0-9]{10}$/;
        return phoneRegex.test(phone);
    };

    const handleNumberChange = (type: string, value: any) => {
        if (type === "countryCode") {
            setPhoneNumber({ ...phoneNumber, countryCode: value });
        }
        if (type === "number") {
            setPhoneNumber({ ...phoneNumber, number: value });
        }

        if (validatePhoneNumber(value)) {
            setDisable(false);
        }
        else {
            setDisable(true);
        }
    };

    const handleEmailChange = (value: string) => {
        setEmail(value);

        if (validateEmail(value)) {
            setDisable(false);
        }
        else {
            setDisable(true);
        }
    }

    const handleTandCStatus = (value: boolean) => {
        setTandCStatus(value);
    };


    const handleGetOtp = async () => {
        try {
            if (!TandCStatus) {
                return ShowAlert("warning", "Kindly Agree Terms and Conditions.");
            }
            // console.log("emailPattern",companyDetails?.emailPattern)
            if (company && email && companyDetails?.emailPattern) {

                let domainPart = email.split("@")[1].toLowerCase();
                let emailPattern = companyDetails?.emailPattern;

                let regex = new RegExp(emailPattern);

                if (!regex.test(domainPart)) {
                    ShowAlert("warning", `Kindly enter your ${companyDetails?.companyName} email`);
                    return;
                }
            }

            setLoading(true);
            setTimeout(async () => {
                try {
                     const data = await sendOtp({ ...phoneNumber, email: email, companyId: company ? companyDetails?._id : undefined });
                    if (!data) return;
                    // Once the OTP is sent, stop the loading state and show the modal
                    setLoading(false);
                    setShowOtpModal(true);
                    if (phoneNumber.number) {
                        ShowAlert("success", "We've sent the OTP to your mobile.");
                    }
                    else if (email) {
                        ShowAlert("success", "We've sent the OTP to your email.");
                    }
                } catch (error: any) {
                    setLoading(false);
                    setShowOtpModal(false);
                    if (error.response?.status === 429) {
                        ShowAlert("warning", error.response?.data?.message || "Too many OTP requests. Please try again after 10 minutes!");
                    } else if (error.response?.data?.message) {
                        ShowAlert("warning", `Couldn't find Pococare account`);
                    } else {
                        ShowAlert("warning", `Please try again`);
                    }
                }
            }, 1000);
        } catch (error: any) {
            ShowAlert("warning", `Something went wrong, please try again`);
            setLoading(false);
        }
    };

    const handleInputEnable = (value: string) => {
        // console.log("inputname", value);
        if (value === "email") {
            setPhoneNumber({
                countryCode: "+91",
                number: "",
            });
            setPhoneDisable(true)
            setEmailDisable(false)
            setDisable(true)
        } else if (value === "phone") {
            setEmail("")
            setEmailDisable(true)
            setPhoneDisable(false);
            setDisable(true)
        }
    }

    return (
        <Box width={"100%"} background={isCorporate ? "rgba(254, 29, 143, 0.03)" : "rgba(238, 253, 249, 1)"}>
            <Flex flexDir={isMobile ? "column" : "row"} gap={"10px"} padding={isMobile ? "95px 15px" : "150px 13.5% 70px 13.5%"} margin={"auto"}>
                <Box flexBasis={"55%"}>
                    <Text
                        as="p"
                        fontFamily="Poppins"
                        fontWeight={300}
                        fontSize={isMobile ? "24px" : "32px"}
                        lineHeight={isMobile ? "28.8px" : "39px"}
                        letterSpacing="0%"
                        textAlign={isMobile ? "center" : "left"}
                    >
                        Medical Emergency
                    </Text>
                    <Text
                        fontFamily="Poppins"
                        fontWeight={700}
                        fontSize={isMobile ? "24px" : "32px"}
                        lineHeight={isMobile ? "28.8px" : "39px"}
                        letterSpacing="0%"
                        textAlign={isMobile ? "center" : "left"}
                    >
                        "Incident to Hospital Admission"
                    </Text>
                    <Text
                        as="p"
                        fontFamily="Poppins"
                        fontWeight={300}
                        fontSize={isMobile ? "24px" : "32px"}
                        lineHeight={isMobile ? "28.8px" : "39px"}
                        letterSpacing="0%"
                        textAlign={isMobile ? "center" : "left"}
                    >
                        Service Any
                        <Text
                            as={"span"}
                            fontFamily="Poppins"
                            fontWeight={300}
                            fontSize={isMobile ? "24px" : "32px"}
                            lineHeight={isMobile ? "28.8px" : "39px"}
                            letterSpacing="0%"
                            color="rgba(254, 29, 143, 1)"
                            textAlign={isMobile ? "center" : "left"}
                        >
                            where
                        </Text>
                    </Text>
                    <Text
                        fontFamily="Poppins"
                        fontWeight={400}
                        fontSize="20px"
                        lineHeight="120%"
                        letterSpacing="0%"
                        color="rgba(0, 0, 0, 0.5)"
                        mt={"20px"}
                        textAlign={isMobile ? "center" : "left"}
                    >
                        “Peace of Mind for you and your family”
                    </Text>
                    <Flex hidden={!isCorporate} maxWidth={"500px"} flexDir={"row"} justifyContent={"center"} gap={"5%"} mt={"30px"}>
                        <Box
                            background="rgba(255, 255, 255, 1)"
                            borderRadius="15px"
                            boxShadow="0px 4px 17.1px 0px rgba(254, 29, 143, 0.08)"
                            width="48%"
                            height="110px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            position="relative"
                            padding={"20px"}
                        >
                            <Image
                                src={companyLogoUrl || `${LogoDirPath}/unavailable.jpg`}
                                alt={company}
                                maxW="100%"
                                maxH="100%"
                                objectFit="contain"
                            />
                        </Box>
                        <Box
                            background="rgba(255, 255, 255, 1)"
                            borderRadius="15px"
                            boxShadow="0px 4px 17.1px 0px rgba(254, 29, 143, 0.08)"
                            width="48%"
                            height="110px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            position="relative"
                            padding={"20px"}
                        >
                            <Image
                                src={`${LogoDirPath}/logo.png`}
                                alt="pococare Logo"
                                maxW="100%"
                                maxH="100%"
                                objectFit="contain"
                                mixBlendMode={"multiply"}
                            />
                        </Box>
                    </Flex>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleGetOtp(); // pass form values here
                        }}
                        style={isMobile ? { maxWidth: "500px", margin: "auto" } : {}}
                    >
                        <Box
                            width="100%"
                            maxWidth="500px"
                            mt={"30px"}
                            onClick={() => handleInputEnable("phone")}
                        >
                            <PhoneInput phoneDisable={inputPhoneDisable} phoneNumber={phoneNumber} handleNumberChange={handleNumberChange} />
                        </Box>
                        <Box
                            maxWidth={"500px"}
                            mt={"10px"}
                        >
                            <Text
                                width={"fit-content"}
                                margin={"auto"}
                                padding={"5px"}
                                fontFamily="Poppins"
                                fontWeight={600}
                                fontSize="14px"
                                lineHeight="120%"
                                letterSpacing="0%"
                                textAlign={"center"}
                                color="#fff"
                                borderRadius={"50%"}
                                background="rgba(254, 29, 143, 1)"
                            >OR</Text>
                        </Box>
                        <Box
                            width="100%"
                            maxWidth="500px"
                            mt={"10px"}
                            onClick={() => handleInputEnable("email")}
                        >
                            <EmailInput email={email} emailDisable={inputEmailDisable} placeholder={isCorporate ? "xyz@company.com" : "Email"} handleEmailChange={handleEmailChange} />
                            {!inputEmailDisable && company &&
                                <Text
                                    p={"10px"}
                                    mt="2"
                                    fontFamily="Poppins"
                                    fontWeight="bold"
                                    fontSize="13px"
                                    lineHeight="1.5"
                                    color="gray.600"
                                >
                                    Please log in using your company-provided email ID.
                                </Text>}

                        </Box>
                        <Box maxWidth={"500px"} mt={"20px"} ml={"5px"}>
                            <Checkbox
                                colorScheme="pink"
                                isChecked={TandCStatus}
                                onChange={(e) => handleTandCStatus(e.target.checked)}
                                size="lg"
                                spacing="1rem"
                                sx={{
                                    'span.chakra-checkbox__control': {
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "10px",
                                        border: "1px solid rgba(0, 0, 0, 0.28)",
                                        boxShadow: "0px 8px 20.9px 0px rgba(0, 0, 0, 0.06)",
                                        background: "#fff",
                                        // When checked
                                        '&[data-checked]': {
                                            background: "#fff",
                                            border: "1px solid rgba(0, 0, 0, 0.28)",
                                        }
                                    },
                                    // Target the checkmark icon
                                    'span.chakra-checkbox__control svg': {
                                        color: "rgba(254, 29, 143, 1)",
                                        transform: "scale(1.5)"      // This sets the tick color
                                    }
                                }}
                            >
                                <Text
                                    as="p"
                                    fontFamily="Poppins"
                                    fontWeight={300}
                                    fontSize="14px"
                                    lineHeight="120%"
                                    letterSpacing="0%"
                                    bg="transparent"
                                    color={"rgba(0, 0, 0, 0.5)"}
                                >
                                    By activating the account, I agree with the{" "}
                                    <ChakraLink href="https://pococare.com/terms&conditions/" isExternal color="rgba(254, 29, 143, 1)" textDecoration="underline">
                                        "Terms & Conditions"
                                    </ChakraLink>{" "}
                                    and{" "}
                                    <ChakraLink href="https://pococare.com/privacyPolicy/" isExternal color="rgba(254, 29, 143, 1)" textDecoration="underline">
                                        "Privacy Policy"
                                    </ChakraLink>
                                </Text>
                            </Checkbox>
                        </Box>
                        <Box>
                            <Button
                                width={"fit-content"}
                                fontFamily={"Poppins"}
                                fontWeight={400}
                                fontSize={"16px"}
                                borderRadius={"92px"}
                                padding={"27px 40px"}
                                color={"#fff"}
                                background="rgba(254, 29, 143, 1)"
                                _hover={{ background: "#12C395;" }}
                                transition={"all 0.5s ease"}
                                variant="solid"
                                lineHeight={"24px"}
                                mt="32px"
                                boxShadow={"rgba(254, 29, 143, 0.25) 0px 18px 43px 0px"}
                                isDisabled={disable}
                                isLoading={isLoading}
                                loadingText="Sending"
                                onClick={handleGetOtp}
                            >
                                {isSamlAuth ? "Sign In" : "Get OTP"}
                            </Button>
                        </Box>
                    </form>
                </Box>
                <Box flexBasis={"45%"} paddingTop={isMobile ? "25px" : "0px"}>
                    <Image
                        src={isCorporate ? `${LogoDirPath}/emergencyLifecycle.svg` : `${LogoDirPath}/emergencyLifecycleCust.svg`}
                        alt="emergency lifecycle"
                        width={"100%"}
                        maxHeight={"566px"}
                        mixBlendMode={isCorporate ? "multiply" : "normal"}
                    />
                     {isCorporate && companyDetails?.disclaimer && (() => {
                        const renderDisclaimer = (text: string) => {
                            const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
                            const parts = text.split(emailRegex);
                            
                            return parts.map((part, index) => {
                                if (emailRegex.test(part)) {
                                    return <ChakraLink key={index} href={`mailto:${part}`} whiteSpace="nowrap" color="rgba(254, 29, 143, 1)" textDecoration="underline" fontWeight={600}>{part}</ChakraLink>;
                                }
                                return part;
                            });
                        };
                        
                        return (
                            <>
                                <Text as="h3" fontFamily="Poppins" fontSize="20px" fontWeight={600} color="rgba(254, 29, 143, 1)" mt="40px" textAlign="left" px="20px" mb="10px">Important Message</Text>
                                <Text fontFamily="Poppins" fontSize="16px" fontWeight={500} lineHeight="1.6" color="rgba(0, 0, 0, 0.85)" mt="0px" textAlign="left" px="20px">
                                    {renderDisclaimer(companyDetails?.disclaimer)}
                                </Text>
                            </>
                        );
                     })()}
                </Box>
            </Flex>
            {showOtpModal && (
                <OtpModal
                    email={email}
                    showOtpModal={showOtpModal}
                    setShowOtpModal={setShowOtpModal}
                    onClose={() => {
                        // Close the OTP modal and set showOtpModal to false
                        setShowOtpModal(false);
                    }}
                />
            )}
        </Box >
    )
}
